import axios from '../../http'
// xb个人中心首页面
class XBpersonalHome {
  // xb获取我的收藏
  postXBPersonalHome() {
    const url = `/api/xb/person/homepage`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
}

export default XBpersonalHome;
